import { main } from './main.js'
import { installableRailDemo } from './installable-rail-demo.js'
import { promptGallery } from './prompt-gallery.js'

export default {
  '/': main,
  '/installable-rail-demo': installableRailDemo,
  '/prompt-gallery': promptGallery
}
